import { render, staticRenderFns } from "./left-main.vue?vue&type=template&id=4df9ebe5&"
import script from "./left-main.vue?vue&type=script&lang=js&"
export * from "./left-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports